// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.231",
  "gitHash": "d7d17400ddb0f7786eb1a9886cbd36c4769ebda6",
  "versionWithHash": "5.5.231-d7d17400ddb0f7786eb1a9886cbd36c4769ebda6"
};
